import React from "react";

const locations = [
  { city: "Lonavala", hotels: 10, rentals: 5, image: "https://5.imimg.com/data5/WL/YE/GLADMIN-47728331/lonavala-tour.png" },
  { city: "Pune ", hotels: 12, rentals: 4, image: "https://lp-cms-production.imgix.net/2019-06/GettyImages-93466728_high.jpg" },
  { city: "Mumbai", hotels: 8, rentals: 6, image: "https://media.istockphoto.com/id/539018660/photo/taj-mahal-hotel-and-gateway-of-india.jpg?s=612x612&w=0&k=20&c=L1LJVrYMS8kj2rJKlQMcUR88vYoAZeWbYIGkcTo6QV0=" },
  { city: "Mahabaleshwar ", hotels: 32, rentals: 12, image: "https://www.mypunepulse.com/wp-content/uploads/2025/02/mahabaleshwar.jpg" },
  // { city: "Houston", hotels: 22, rentals: 16, image: "/img/city/ct-5.png" },
  // { city: "San Jose", hotels: 25, rentals: 15, image: "/img/city/ct-6.png" },
  // { city: "Denver", hotels: 29, rentals: 14, image: "/img/city/ct-1.png" },
  // { city: "California", hotels: 22, rentals: 12, image: "/img/city/ct-10.png" },
];

const PopularLocations = () => {
  return (
    <section className="gray-simple">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-xl-8 col-lg-9 col-md-11 col-sm-12">
            <div className="secHeading-wrap text-center mb-5">
              <h2>Popular Locations To Visit</h2>
              {/* <p>Cicero famously orated against his political opponent Lucius Sergius Catilina.</p> */}
            </div>
          </div>
        </div>

        <div className="row align-items-center justify-content-center g-xl-4 g-lg-4 g-3">
          {locations.map((loc, index) => (
            <div key={index} className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
              <div className="card destination-card border-0 rounded-3 overflow-hidden m-0">
                <div className="destination-card-wraps position-relative">
                  <div className="destination-card-thumbs">
                    <div className="destinations-pics">
                      <a href="#">
                        <img src={loc.image} className="img-fluid" alt={loc.city} />
                      </a>
                    </div>
                  </div>
                  <div className="destination-card-description position-absolute start-0 bottom-0 ps-4 pb-4 z-2">
                    <div className="exploterr-text">
                      <h3 className="text-light fw-bold mb-1">{loc.city}</h3>
                      {/* <p className="detail ellipsis-container text-light">
                        <span className="ellipsis-item__normal">{loc.hotels} Hotels</span>
                        <span className="separate ellipsis-item__normal"> | </span>
                        <span className="ellipsis-item">{loc.rentals} Rentals</span>
                      </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularLocations;
